export var isRequestPending = function (status) {
    return status === 'pending';
};
